<template>
    <div>
        <v-row>
            <v-col cols="12" md="6">
                <v-card outlined>
                    <v-card-title class="d-flex justify-center primary--text text-subtitle-2">
                        Aprendizaje por área
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>

                            <v-col cols="12">
                                <v-radio-group v-model="typeEval" row @change="getMetricaArea">
                                    <v-radio label="Somos hábiles" value="SOMOS HÁBILES"></v-radio>
                                    <v-radio label="Simulador" value="SIMULADOR"></v-radio>
                                    <v-radio label="Evaluaciones" value="EVALUACION"></v-radio>
                                </v-radio-group>
                            </v-col>
                            <v-col cols="12">
                                <div id="chart">
                                    <apexchart type="bar" height="350" :options="chartOptions" :series="series">
                                    </apexchart>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-subtitle>
                        <span class="d-flex text-center">
                            El siguiente gráfico representa la comparativa entre áreas
                            especificando el número de evaluaciones y el porcentaje que representa, tanto el número
                            de aprobados, como de desaprobados
                        </span>
                    </v-card-subtitle>
                </v-card>

            </v-col>
            <v-col cols="12" md="6">
                <v-card outlined>
                    <v-card-title class="d-flex justify-center primary--text text-subtitle-2">
                        Comparativa por área
                    </v-card-title>
                    <v-card-text>
                        <v-row dense>
                            <v-col cols="12">
                                <v-autocomplete v-model="AreasSeleccionadas" :items="Areas" outlined dense chips
                                    small-chips label="Áreas" multiple item-text="name" item-value="id"
                                    return-object></v-autocomplete>
                            </v-col>
                            <v-col cols="12">
                                <div id="chart">
                                    <apexchart type="line" height="350" :options="chartOptions2" :series="series2">
                                    </apexchart>
                                </div>
                            </v-col>
                        </v-row>
                    </v-card-text>
                    <v-card-subtitle class="d-flex text-center">
                        <span>
                            El siguiente gráfico muestra el progreso de las notas del estudiante en cada una de las
                            áreas . Se puede utilizar la métrica de manera en la que se puedan comparar
                            áreas específicas y ver si se subió el promedio de un área en específico a costa de
                            otra.
                        </span>
                    </v-card-subtitle>
                </v-card>

            </v-col>
            <!-- {{ typeEval }} -->
        </v-row>

        <!-- <div style="display: none;">
            {{ chartOptions.xaxis.categories }}
        </div> -->
    </div>
</template>

<script>
import axios from "@/helpers/axios";
import VueApexCharts from 'vue-apexcharts'

export default {
    props: ['filter'],
    components: {
        apexchart: VueApexCharts,
    },
    data: () => ({

        AreasListed: [],
        Areasresponse: [],
        Areas: [],
        // chartKey: "",
        dataAprobado: [],
        dataNumAprobado: "",
        dataDesaprobado: [],
        dataNoevaluada: [],
        AreasSeleccionadas: [],
        typeEval: "SOMOS HÁBILES",
        // dataprueba: [
        //     {
        //         id_area: 120,
        //         desc_area: "Ciencia y Tecnología",
        //         aprobados: "1",
        //         desaprobados: "4",
        //         no_rendidos: "0",
        //         evaluaciones: [
        //             [
        //                 [
        //                     {
        //                         "idexamen": 1276,
        //                         "nombre_completo": "PEDRITO  LOPEZ  GONZALEZ",
        //                         "fecha_creacion": "2024-01-29 17:23:53",
        //                         "estado": false,
        //                         "tipo_contenido": 1,
        //                         "verdaderas": 1,
        //                         "cantidad_preguntas": 5,
        //                         "aprobado": false
        //                     },
        //                     {
        //                         "idexamen": 1277,
        //                         "nombre_completo": "PEDRITO  LOPEZ  GONZALEZ",
        //                         "fecha_creacion": "2024-01-29 17:24:44",
        //                         "estado": false,
        //                         "tipo_contenido": 1,
        //                         "verdaderas": 3,
        //                         "cantidad_preguntas": 5,
        //                         "aprobado": true
        //                     },
        //                     {
        //                         "idexamen": 1278,
        //                         "nombre_completo": "PEDRITO  LOPEZ  GONZALEZ",
        //                         "fecha_creacion": "2024-01-29 17:25:06",
        //                         "estado": false,
        //                         "tipo_contenido": 1,
        //                         "verdaderas": 0,
        //                         "cantidad_preguntas": 5,
        //                         "aprobado": false
        //                     },
        //                     {
        //                         "idexamen": 1279,
        //                         "nombre_completo": "PEDRITO  LOPEZ  GONZALEZ",
        //                         "fecha_creacion": "2024-01-29 17:25:33",
        //                         "estado": false,
        //                         "tipo_contenido": 1,
        //                         "verdaderas": 1,
        //                         "cantidad_preguntas": 5,
        //                         "aprobado": false
        //                     },
        //                     {
        //                         "idexamen": 1280,
        //                         "nombre_completo": "PEDRITO  LOPEZ  GONZALEZ",
        //                         "fecha_creacion": "2024-01-29 17:25:56",
        //                         "estado": false,
        //                         "tipo_contenido": 1,
        //                         "verdaderas": 2,
        //                         "cantidad_preguntas": 5,
        //                         "aprobado": false
        //                     }
        //                 ]
        //             ]
        //         ]
        //     },
        //     {
        //         id_area: 120,
        //         desc_area: "Matematica",
        //         aprobados: "1",
        //         desaprobados: "4",
        //         no_rendidos: "0",
        //         evaluaciones: [
        //             [
        //                 [
        //                     {
        //                         "idexamen": 1276,
        //                         "nombre_completo": "PEDRITO  LOPEZ  GONZALEZ",
        //                         "fecha_creacion": "2024-01-29 17:23:53",
        //                         "estado": false,
        //                         "tipo_contenido": 1,
        //                         "verdaderas": 1,
        //                         "cantidad_preguntas": 5,
        //                         "aprobado": false
        //                     },
        //                     {
        //                         "idexamen": 1277,
        //                         "nombre_completo": "PEDRITO  LOPEZ  GONZALEZ",
        //                         "fecha_creacion": "2024-01-29 17:24:44",
        //                         "estado": false,
        //                         "tipo_contenido": 1,
        //                         "verdaderas": 3,
        //                         "cantidad_preguntas": 5,
        //                         "aprobado": true
        //                     },
        //                     {
        //                         "idexamen": 1278,
        //                         "nombre_completo": "PEDRITO  LOPEZ  GONZALEZ",
        //                         "fecha_creacion": "2024-01-29 17:25:06",
        //                         "estado": false,
        //                         "tipo_contenido": 1,
        //                         "verdaderas": 0,
        //                         "cantidad_preguntas": 5,
        //                         "aprobado": false
        //                     },
        //                     {
        //                         "idexamen": 1279,
        //                         "nombre_completo": "PEDRITO  LOPEZ  GONZALEZ",
        //                         "fecha_creacion": "2024-01-29 17:25:33",
        //                         "estado": false,
        //                         "tipo_contenido": 1,
        //                         "verdaderas": 1,
        //                         "cantidad_preguntas": 5,
        //                         "aprobado": false
        //                     },
        //                     {
        //                         "idexamen": 1280,
        //                         "nombre_completo": "PEDRITO  LOPEZ  GONZALEZ",
        //                         "fecha_creacion": "2024-01-29 17:25:56",
        //                         "estado": false,
        //                         "tipo_contenido": 1,
        //                         "verdaderas": 2,
        //                         "cantidad_preguntas": 5,
        //                         "aprobado": false
        //                     }
        //                 ]
        //             ]
        //         ]
        //     }
        // ],

        series2: [],
        chartOptions2: {
            chart: {
                height: 350,
                type: 'line',
            },

            stroke: {
                curve: 'smooth',
                width: 2,
                // dashArray: 5
            },
            fill: {
                type: 'solid',
                opacity: [0.35, 1],
            },
            labels: [],
            markers: {
                size: 5
            },
            yaxis: [
                {
                    opposite: true,
                },
            ],


            // xaxis: {
            //     type: 'datetime',
            //     labels: {
            //         formatter: function (value, timestamp) {
            //             // Crear un objeto Date usando el timestamp
            //             const date = new Date(timestamp);
            //             // Devuelve solo la parte de la fecha en el formato deseado
            //             return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
            //             // return `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')}`;
            //         }
            //     }
            // },

            tooltip: {
                shared: true,
                intersect: false,
                y: {
                    formatter: function (y) {
                        if (typeof y !== "undefined") {
                            return y.toFixed(0) + " points";
                        }
                        return y;
                    }
                },
                // x: {
                //     format: 'dd MMM yyyy HH:mm:ss' // Este es el formato de la fecha completa para la tooltip
                // }
            }
        },

        series: [],
        chartOptions: {
            chart: {
                type: 'bar',
                height: 350,
                stacked: true,
                stackType: '100%'
            },
            stroke: {
                width: 1,
                colors: ['#fff']
            },


            responsive: [{
                breakpoint: 480,
                options: {
                    legend: {
                        position: 'bottom',
                        offsetX: -10,
                        offsetY: 0
                    }
                }
            }],
            //Data dentro de las barras
            dataLabels: {
                formatter: (val) => {
                    return parseInt(val).toFixed(2) + ' %';
                }
            },
            plotOptions: {
                bar: {
                    horizontal: false,
                    distributed: false
                }

            },
            xaxis: {
                // areas graficadas
                categories: [],
            },
            tooltip: {
                custom: function ({ series, seriesIndex, dataPointIndex, w }) {
                    return '<div class="custom-tooltip">' +
                        '<strong>' + w.globals.labels[dataPointIndex] + '</strong>' +
                        '<span>' + 'Cantidad : ' + + series[seriesIndex][dataPointIndex] + '</span>' +
                        '</div>';
                }
            },
            fill: {
                opacity: 1
            },
            colors: ['#008FFB', '#ff7477', '#f7cd0f'],
            yaxis: {
                // stepSize: 10,
                labels: {
                    formatter: (val) => {
                        if (val > 100 || val < 0) {
                            return ""
                        }
                        return val + "%"
                    },
                },
            },


        },

    }),

    methods: {


        // metrica de las areas

        async getMetricaArea() {
            this.AreasListed = [];
            this.series = [];
            try {
                const response = await axios.get("/metricaSomosHabiles/barChartByArea",
                    {
                        params: {
                            id_al: this.filter.id_alumno,
                            tipo_eval: this.typeEval
                        }
                    });

                this.Areasresponse = response.data.data;
                this.AreasListed = this.Areasresponse.map(item => item.desc_area);
                this.dataAprobado = this.Areasresponse.map(item => parseInt(item.aprobados).toFixed(2));
                this.dataDesaprobado = this.Areasresponse.map(item => parseInt(item.desaprobados).toFixed(2));
                this.dataNoevaluada = this.Areasresponse.map(item => parseInt(item.no_rendidos).toFixed(2));

                this.dataNumAprobado = this.dataAprobado;

                this.chartOptions = {
                    ...this.chartOptions,
                    xaxis: {
                        ...this.chartOptions.xaxis, // Esto copia la configuración existente del eje X
                        categories: this.AreasListed // Esto establece las nuevas categorías
                    }
                };

                this.$nextTick(() => {
                    if (this.$refs.myChart) {
                        this.$refs.myChart.updateOptions(this.chartOptions, true, true);
                    }
                });
                this.series = [
                    {
                        name: 'Aprobado',
                        group: 'actual',
                        data: this.dataAprobado.map(Number),
                    },

                    {
                        name: 'Desaprobado',
                        group: 'actual',
                        data: this.dataDesaprobado.map(Number),
                    },
                    {
                        name: 'No calificado',
                        group: 'actual',
                        data: this.dataNoevaluada.map(Number),
                    }
                ];

                return this.series

            } catch (error) {
                console.error(error);
            }
        },


        async fetchDataFromAPI() {
            this.series2 = [];
            this.Areas = [];
            console.log('Se ejucuto el limpiado');
            const response = await axios.get("/metricaSomosHabiles/barChartByArea", {
                params: {

                    tipo_eval: "SOMOS HÁBILES",
                    id_al: this.filter.id_alumno,
                    status: false
                }
            });
            this.Areas = response.data.data;
            this.processAPIData(this.Areas);
        },

        processAPIData(apiData) {
            this.Areas = apiData.map(item => ({
                id: item.id_area,
                name: item.desc_area,
                data: item.evaluaciones.map(ev => {

                    const date = new Date(ev.fecha_creacion);

                    const formattedDate = `${date.getFullYear()}-${(date.getMonth() + 1).toString().padStart(2, '0')}-${date.getDate().toString().padStart(2, '0')} ${date.getHours().toString().padStart(2, '0')}:${date.getMinutes().toString().padStart(2, '0')}:${date.getSeconds().toString().padStart(2, '0')}`;
                    return {
                        x: formattedDate,
                        y: ev.verdaderas
                    }
                }),
                type: "area"
            }));

            this.updateSeries(this.Areas);
        },

        updateSeries(selectedAreas) {
            this.series2 = selectedAreas.map(area => ({
                name: area.name,
                data: area.data
            }));
        },
    },

    mounted() {
        this.fetchDataFromAPI();
        this.getMetricaArea();
    },

    watch: {
        AreasSeleccionadas: {
            handler(newVal) {
                this.series2 = newVal.map(area => ({
                    name: area.name,
                    data: area.data
                }));
            },
            deep: true
        },



    }
}

</script>

<style>
.custom-tooltip {
    /* color: white; */
    display: grid;
    padding: 5px 10px;
    border-radius: 5px;
}
</style>